<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.planned_loadings' | translate }}
    v-card-content(full)
      table.table
        thead.table__header
          tr.table__row.table__row--head
            th.table__cell {{ 'base.ingredients' | translate }}
            th.table__cell {{ 'base.weight_plan_kg' | translate }}
            th.table__cell {{ 'base.weight_fact_kg' | translate }}
        tbody
          tr.table__row(
            v-for="item in items"
            :key="item.id")
            td.table__cell {{ shortStr(item.name) }}
            td.table__cell {{ item.plan_weight }}
            td.table__cell
              ui-number-input(
                full
                reactive
                v-model="item.fact_weight")
    v-card-actions
      v-btn(
        :loading="progress"
        @click="load")
        | {{ 'base.load' | translate }}
</template>

<script>
import api from '@/api'

import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'

export default {
  name: 'ScheduleLoadDialog',

  props: {
    item: Object
  },

  components: {
    UiNumberInput
  },

  mounted () {
    this.initData()
  },

  data: () => ({
    items: [],
    progress: false
  }),

  methods: {
    initData () {
      for (let item of this.item.schedule_ration.ingredients) {
        let ingredient = {
          id: item.id,
          name: item.name,
          plan_weight: Math.floor(item.plan_weight),
          fact_weight: Math.floor(item.plan_weight),
          loaded_at: new Date(new Date().toUTCString()).toISOString()
        }
        this.items.push(ingredient)
      }
    },

    async load () {
      this.progress = true
      const id = this.item.id
      const payload = {
        schedule_ration: {
          id: this.item.schedule_ration.id,
          ingredients: this.items
        }
      }
      const { errors } = await api.schedule.updateLoad(id, payload)
      if (!errors) {
        this.$emit('update')
        this.closeClick()
        this.$store.dispatch('updatePlanning')
      }
      this.progress = false
    },

    shortStr (str) {
      return str.length > 18 ? str.substring(0, 15) + '...' : str
    },

    closeClick () {
      this.$emit('on-close')
    }
  }
}
</script>

<style scoped>
.table__cell:last-child {
  width: 200px;
}
</style>
